import { Template } from "./template.js";

const Notifications = {
  name: "Notifications",
  template: Template,
  data() {
    return {
      selectedValue: "",
      new_notifications: [],
      filters: [
        {
          text: this.$t("messages.break"),
          value: "wire_error",
        },
        {
          text: this.$t("messages.lowBattery"),
          value: "battery_error",
        },
        {
          text: this.$t("messages.sodden"),
          value: "isol_error",
        },
        {
          text: this.$t("messages.noSignal"),
          value: "no_signal",
        },
      ],

      fields: [
        {
          key: "icons",
          label: "",
        },
        {
          key: "measure_time",
          label: this.$t("messages.time"),
        },
        {
          key: "serial",
          label: this.$t("messages.modemSN"),
        },
        {
          key: "tube_name",
          label: this.$t("messages.tube"),
        },
        {
          key: "message",
          label: this.$t("messages.message"),
          class: "message-column-width",
        },
      ],
      notifications: [],
    };
  },

  created() {
    var cont = this;
    this.getNotifications();
  },

  computed: {
    //обновляем значения в таблице в зависимости от выбранного фильтра
    filterNotifications() {
      if (this.selectedValue == "") {
        this.new_notifications = this.notifications;
      } else {
        this.new_notifications = [];
        for (let i = 0; i < this.notifications.length; i++) {
          if (this.notifications[i].message_types[this.selectedValue] == true) {
            this.new_notifications.push(this.notifications[i]);
          }
        }
      }
      return true;
    },
  },
  updated() {
    this.filters[0].text = this.$t("messages.break");
    this.filters[1].text = this.$t("messages.lowBattery");
    this.filters[2].text = this.$t("messages.sodden");
    this.filters[3].text = this.$t("messages.noSignal");
    this.fields[1].label = this.$t("messages.time");
    this.fields[2].label = this.$t("messages.modemSN");
    this.fields[3].label = this.$t("messages.tube");
    this.fields[4].label = this.$t("messages.message");
  },

  methods: {
    resetFilters() {
      this.selectedValue = "";
      return true;
    },

    getNotifications() {
      var cont = this;
      this.$API(
        "static_data",
        "notifications",
        {},
        function (data) {
          cont.notifications = data;
        },
        function (errorText) {
          console.log(errorText);
        }
      );
    },

    tubeIcons(item) {
      let icons = "";
      icons += item.message_types.wire_error ? "⚡︎" : "";
      icons += item.message_types.isol_error ? "🚫" : "";
      icons += item.message_types.battery_error ? "🔋" : "";
      icons += item.message_types.no_signal ? "⏰" : "";
      return icons;
    },

    getMessage(item) {
      let message = "";
      message += item.message_types.wire_error
        ? this.$t("messages.break2")
        : "";
      message += item.message_types.isol_error
        ? this.$t("messages.sodden2")
        : "";
      message += item.message_types.battery_error
        ? this.$t("messages.lowBattery2")
        : "";
      message += item.message_types.no_signal
        ? this.$t("messages.noSignal2")
        : "";
      return message;
    },
  },
};
export { Notifications };



// WEBPACK FOOTER //
// ./src/app/js/components/page5_notifications/notifications/component.js